import React from 'react'

export default function TruckIcon() {
  return <img src='assets/truck-icon.png' alt='Operations Logo' height={70} />
}
